import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    barChart: {
      borderRadius: 8,
      padding: '3rem 2rem 0 2rem',

      '& .MuiTypography-h2': {
        fontSize: '1.6rem',
        fontWeight: 500,
        marginRight: '0.8rem',
      },
      '& svg': {
        fontSize: '1.6rem',
        color: '#727970',
      },
    },
    tooltip: {
      backgroundColor: '#505356',
      color: '#FFFFFF',
      fontSize: '1.2rem',
      lineHeight: '1.8rem',
      padding: '0.5rem',
      borderRadius: 5,
      width: '16rem',
      fontWeight: 500,
      whiteSpace: 'normal',

      '& p': {
        maxWidth: '23ch',
        margin: 0,
        overflow: 'hidden',
        wordWrap: 'break-word',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 2, // Limita a 2 linhas
        WebkitBoxOrient: 'vertical',
      },
    },
    cicle: {
      width: 12,
      height: 12,
      borderRadius: '50%',
      marginRight: 8,
    },
    legend: {
      display: 'flex',
      listStyle: 'none',
      padding: 0,
      '& > li': {
        display: 'flex',
        alignItems: 'center',
        marginRight: 20,
        '& > span': {
          color: '#718EBF',
          fontSize: 12,
          fontWeight: 600,
          whiteSpace: 'nowrap',
        },
      },
    },
    tooltipInfo: {
      backgroundColor: '#505356',
      color: '#FFFFFF',
      maxWidth: '27rem',
      fontSize: '1.2rem',
      padding: '0.4rem 0.8rem',
      border: 'none',
      borderRadius: 5,
    },
  }),
)
;('')
